interface Realms {
  NA: string;
  EU: string;
  FE: string;
}

export const REALMS: Realms = { NA: "na", EU: "eu", FE: "fe" };

// Reference https://code.amazon.com/packages/PVAccountingCDK/blobs/mainline/--/lib/marketplaces.ts
// Realms cross-checked against https://code.amazon.com/packages/PVVariableCommon/blobs/mainline/--/src/main/java/com/amazon/variable/core/country/Marketplace.java
export const MARKETPLACE_TO_REALM: Record<string, string> = {
  A39IBJ37TRP1C6: REALMS.FE, // AUSTRALIA_PROD
  A1RNPCQ4K8U27I: REALMS.FE, // AUSTRALIA_ DEVO
  AMEN7PMS3EDWL: REALMS.EU, // BELGIUM_PROD
  A1YFOMBPFBRY22: REALMS.EU, // BELGIUM_DEVO
  A2Q3Y263D00KWC: REALMS.NA, // BRAZIL_PROD
  AZXD3QD5B39HD: REALMS.NA, // BRAZIL_DEVO
  A2EUQ1WTGCTBG2: REALMS.NA, // CANADA
  A2WDZJZ5TCRMLH: REALMS.NA, // CHILE_PROD
  A2IDBVIE7EAGN4: REALMS.NA, // CHILE_DEVO
  A1ZXRLSQW2V54D: REALMS.NA, // COLOMBIA_PROD
  A1NOHO22DE3OHQ: REALMS.NA, // COLOMBIA_DEVO
  ARBP9OOSHTCHU: REALMS.EU, // EGYPT_PROD
  AUJPM9XGFJRC7: REALMS.EU, // EGYPT_DEVO
  A13V1IB3VIYZZH: REALMS.EU, // FRANCE
  A1PA6795UKMFR9: REALMS.EU, // GERMANY
  A21TJRUUN4KGV: REALMS.EU, // INDIA
  A2XZLSVIQ0F4JT: REALMS.EU, //INDIA_DEV
  A3BUE4CVFSERTV: REALMS.FE, // INDONESIA_PROD
  A3AXUV5MEX8R86: REALMS.FE, // INDONESIA_DEVO
  A28R8C7NBKEWEA: REALMS.EU, // IRELAND_PROD
  AQGJ466SKA0F0: REALMS.EU, // IRELAND_DEVO
  APJ6JRA9NG5V4: REALMS.EU, // ITALY_PROD
  A3HOBANJMCMD83: REALMS.EU, // ITALY_DEVO
  A1VC38T7YXB528: REALMS.FE, // JAPAN
  A1AM78C64UM0Y8: REALMS.NA, // MEXICO_PROD
  A3P3J5A7D2ZVXI: REALMS.NA, // MEXICO_DEVO
  A1805IZSGTT6HS: REALMS.EU, // NETHERLANDS_PROD
  A1M3WC0SJ3A38T: REALMS.EU, // NETHERLANDS_DEVO
  A3OCL2LJ6GDH9T: REALMS.EU, // NIGERIA_PROD
  A3PJZM0QIA8QDU: REALMS.EU, // NIGERIA_DEVO
  A1C3SOZRARQ6R3: REALMS.EU, // POLAND_PROD
  AKY4K4WKH21YQ: REALMS.EU, // POLAND_DEVO
  A17E79C6D8DWNP: REALMS.EU, // SAUDI_ARABIA_PROD
  A1MQPSGJ6U9Q54: REALMS.EU, // SAUDI_ARABIA_DEVO
  A19VAU5U5O7RUS: REALMS.FE, // SINGAPORE_PROD
  A1DQ6JV7I20JSG: REALMS.FE, // SINGAPORE_DEVO
  AE08WJ6YKNBMC: REALMS.EU, // SOUTHAFRICA_PROD
  A3TFQ1G9L8TQ5L: REALMS.EU, // SOUTHAFRICA_DEVO
  A1RKKUPIHCS9HS: REALMS.EU, // SPAIN_PROD
  AJZF8LZ1EJVJN: REALMS.EU, // SPAIN_DEVO
  A3K6Y4MI8GDYMT: REALMS.EU, // ROE_EU_PROD
  A1MJEQWJOUEPEQ: REALMS.EU, // ROE_EU_DEVO
  A2MFUE2XK8ZSSY: REALMS.EU, // ROW_EU_PROD
  A1D7Z662KHSYZY: REALMS.EU, // ROW_EU_DEVO
  A15PK738MTQHSO: REALMS.FE, // ROW_FE_PROD
  A9QSUUOYRWVOG: REALMS.FE, // ROW_FE_DEVO
  ART4WZ8MWBX2Y: REALMS.NA, //  ROW_NA_PROD
  A3U49GLEJ1PS4Y: REALMS.NA, // ROW_NA_DEVO
  A2NODRKZP88ZB9: REALMS.EU, // SWEDEN_PROD
  AT614YYYNOC1S: REALMS.EU, // SWEDEN_DEVO
  A2C3YW2ZWP46WB: REALMS.FE, // THAILAND_PROD
  A1R88CJ2V91TQ4: REALMS.FE, // THAILAND_DEVO
  A3CQBQD3RGPJR8: REALMS.EU, // TURKEY_DEVO
  A33AVAJ2PDY3EV: REALMS.EU, // TURKEY_PROD
  A34GYYCZVDBSIK: REALMS.EU, //UAE_DEVO
  A2VIGQ35RCS4UG: REALMS.EU, //UAE_PROD
  A1F83G8C2ARO7P: REALMS.EU, // UK
  ATVPDKIKX0DER: REALMS.NA, // US
};

/**
 * Resolves the realm for a marketplace, falling back to NA when the marketplace is unknown.
 *
 * Marketplaces are onboarded upstream (PVAccountingCDK) before this map is updated, so an
 * unmapped ID is expected rather than exceptional. Callers build URLs from the realm, so
 * returning a default keeps links renderable — a link pointing at the wrong realm is far
 * better than an undefined realm crashing the whole transaction page.
 */
export const getRealmFromMarketplace = (marketplaceId?: string): string =>
  (marketplaceId ? MARKETPLACE_TO_REALM[marketplaceId] : undefined) ??
  REALMS.NA;

export const isKnownMarketplace = (marketplaceId?: string): boolean =>
  !!marketplaceId && marketplaceId in MARKETPLACE_TO_REALM;

export const MARKETPLACE_TO_COUNTRY_CODE: Record<string, string> = {
  A39IBJ37TRP1C6: "AU",
  A1RNPCQ4K8U27I: "AU_DEVO",
  AMEN7PMS3EDWL: "BE",
  A1YFOMBPFBRY22: "BE_DEVO",
  A2Q3Y263D00KWC: "BR",
  AZXD3QD5B39HD: "BR_DEVO",
  A2EUQ1WTGCTBG2: "CA",
  A2WDZJZ5TCRMLH: "CL",
  A2IDBVIE7EAGN4: "CL_DEVO",
  A1ZXRLSQW2V54D: "CO",
  A1NOHO22DE3OHQ: "CO_DEVO",
  A1PA6795UKMFR9: "DE",
  ARBP9OOSHTCHU: "EG",
  AUJPM9XGFJRC7: "EG_DEVO",
  A1RKKUPIHCS9HS: "ES",
  AJZF8LZ1EJVJN: "ES_DEVO",
  A13V1IB3VIYZZH: "FR",
  A1F83G8C2ARO7P: "GB",
  A3BUE4CVFSERTV: "ID",
  A3AXUV5MEX8R86: "ID_DEVO",
  A28R8C7NBKEWEA: "IE",
  AQGJ466SKA0F0: "IE_DEVO",
  A21TJRUUN4KGV: "IN",
  A2XZLSVIQ0F4JT: "IN_DEVO",
  APJ6JRA9NG5V4: "IT",
  A3HOBANJMCMD83: "IT_DEVO",
  A1VC38T7YXB528: "JP",
  A1AM78C64UM0Y8: "MX",
  A3P3J5A7D2ZVXI: "MX_DEVO",
  A3OCL2LJ6GDH9T: "NG",
  A3PJZM0QIA8QDU: "NG_DEVO",
  A1805IZSGTT6HS: "NL",
  A1M3WC0SJ3A38T: "NL_DEVO",
  A1C3SOZRARQ6R3: "PL",
  AKY4K4WKH21YQ: "PL_DEVO",
  A17E79C6D8DWNP: "SA",
  A1MQPSGJ6U9Q54: "SA_DEVO",
  A19VAU5U5O7RUS: "SG",
  A1DQ6JV7I20JSG: "SG_DEVO",
  A2C3YW2ZWP46WB: "TH",
  A1R88CJ2V91TQ4: "TH_DEVO",
  AE08WJ6YKNBMC: "ZA",
  A3TFQ1G9L8TQ5L: "ZA_DEVO",
  A3K6Y4MI8GDYMT: "ROE_EU_PROD",
  A1MJEQWJOUEPEQ: "ROE_EU_DEVO",
  A2MFUE2XK8ZSSY: "ROW_EU_PROD",
  A1D7Z662KHSYZY: "ROW_EU_DEVO",
  A15PK738MTQHSO: "ROW_FE_PROD",
  A9QSUUOYRWVOG: "ROW_FE_DEVO",
  ART4WZ8MWBX2Y: "ROW_NA_PROD",
  A3U49GLEJ1PS4Y: "ROW_NA_DEVO",
  A2NODRKZP88ZB9: "SE",
  AT614YYYNOC1S: "SE_DEVO",
  A3CQBQD3RGPJR8: "TR_DEVO",
  A33AVAJ2PDY3EV: "TR",
  A34GYYCZVDBSIK: "AE_DEVO",
  A2VIGQ35RCS4UG: "AE",
  ATVPDKIKX0DER: "US",
};

export const getCountryCodeFromMarketplace = (
  marketplaceId: string
): string => {
  return MARKETPLACE_TO_COUNTRY_CODE[marketplaceId] || "";
};

// ROW/ROE marketplaces are multi-country buckets (e.g. ROW_NA, ROE_EU) whose JEM files are keyed
// per buyer country rather than per bucket.
export const isPerCountryBucketMarketplace = (marketplace: string): boolean =>
  marketplace.startsWith("ROW") || marketplace.startsWith("ROE");

/**
 * Resolves the country code to send when triggering a shadow test.
 *
 * The marketplace-derived country is authoritative and wins over `declaredCountryCode`, which can
 * be wrong upstream (e.g. an FR order incorrectly tagged as DE) and would otherwise cause the wrong
 * JEM file to be selected. The one exception is ROW/ROE buckets: their JEMs are per-country, so the
 * declared (buyer) country is the correct key there and takes precedence.
 */
export const resolveShadowTestCountryCode = (
  marketplace: string,
  declaredCountryCode?: string,
  fallbackCountryCode?: string
): string => {
  if (isPerCountryBucketMarketplace(marketplace)) {
    return declaredCountryCode || fallbackCountryCode || marketplace;
  }
  return marketplace || declaredCountryCode || fallbackCountryCode || "";
};

// Reverse lookup: country code → marketplace ID (prod only)
export const COUNTRY_TO_MARKETPLACE: Record<string, string> =
  Object.fromEntries(
    Object.entries(MARKETPLACE_TO_COUNTRY_CODE)
      .filter(([, cc]) => !cc.includes("_"))
      .map(([mpId, cc]) => [cc, mpId])
  );

export const getRealmFromCountryCode = (countryCode: string): string =>
  getRealmFromMarketplace(COUNTRY_TO_MARKETPLACE[countryCode]);
